import { useDispatch, useSelector } from 'react-redux';
import { combineReducers } from 'redux';
import activeCurrencyCode from './ActiveCurrencyCode';
import activeTrials from './ActiveTrials';
import businessObjectives from './BusinessObjectives';
import companyDetails from './CompanyDetails';
import compare from './Compare';
import config from './Config';
import country from './Country';
import customerCurrencyCode from './CustomerCurrencyCode';
import defaultCurrencyCode from './DefaultCurrencyCode';
import experimentation from './Experimentation';
import features from './Features';
import marketingContacts from './MarketingContacts';
import numContactsInCrm from './NumContactsInCrm';
import phoneNumbers from './PhoneNumbers';
import productInventory from './ProductInventory';
import abstractedProducts from './Products';
import promotions from './Promotions';
import publicFeatureFlags from './PublicFeatureFlags';
import purchaseMotionsByLocation from './PurchaseMotionsByLocation';
import queryParamTerm from './QueryParamTerm';
import recommendedHub from './RecommendedHub';
import requests from './Requests';
import retail from './Retail';
import seatsInventory from './SeatsInventory';
import auth from './auth';
import requiredOnboarding from './requiredOnboarding';
export const rootReducer = combineReducers({
  auth,
  requiredOnboarding,
  requests,
  abstractedProducts,
  promotions,
  companyDetails,
  config,
  customerCurrencyCode,
  activeCurrencyCode,
  retail,
  numContactsInCrm,
  marketingContacts,
  phoneNumbers,
  purchaseMotionsByLocation,
  queryParamTerm,
  publicFeatureFlags,
  country,
  productInventory,
  features,
  compare,
  businessObjectives,
  seatsInventory,
  activeTrials,
  defaultCurrencyCode,
  recommendedHub,
  experimentation
});

// This type represents the state of your root reducer,
// and can be useful when creating selectors

// Should be used in place of useDispatch throughout the application
export function useAppDispatch() {
  return useDispatch();
}
export const useAppSelector = useSelector;